export default __webpack_public_path__ + "static/media/purple-planet.e60e42d1.png";